

























import { mapActions } from 'vuex';
import { BFormInput } from 'bootstrap-vue';

import GenericCard from '@/components/cards/GenericCard.vue';
import { ModalSize } from '@/components/zen_modal/types';

export default {
  name: 'ListingSaveFavoriteModal',
  components: {
    BFormInput,
    GenericCard,
  },
  props: {
    saveAsNew: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      name: '',
    };
  },
  created() {
    this.changeModalSize(ModalSize.Small);
  },
  methods: {
    ...mapActions({
      changeModalSize: 'modals/changeSize',
      cancelModal: 'modals/cancel',
      confirmModal: 'modals/confirm',
    }),

    title(saveAsNew: boolean): string {
      return saveAsNew ? 'Save as new favorite' : 'Save to favorite';
    },
    text(saveAsNew: boolean): string {
      return saveAsNew
        ? 'Saving this view as a new favorite will save the applied visible columns, their order, and their sizes.'
        : 'Saving this view as a favorite will save the applied visible columns, their order, and their sizes.';
      // TODO: change to these after filters and sorting are persisted:
      // return saveAsNew
      //   ? 'Saving this view as a new favorite will save the visible columns, filters, and sorts applied.'
      //   : 'Saving this view as a favorite will save the visible columns, filters, and sorts applied.';
    },

    cancel(): void {
      this.cancelModal();
    },
    save(): void {
      const newFavorite = { name: this.name };

      this.confirmModal(newFavorite);
    },
  },
};
